import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Header } from "./components/Home/header";
import { Features } from "./components/feature/features";
import { Home1 } from "./components/home1/home1";
import { Services } from "./components/services/services";
import { ServiceDetail } from "./components/services/ServiceDetail";
import { Testimonials } from "./components/testimonials/testimonials";
import { SpecializedTech } from "./components/SpecializedTech/SpecializedTech";
import { Contact } from "./components/contact/contact";
import { WhoWeAre } from "./components/whoweare/whoweare";
import Certifications from "./components/certifications/certifications";
import Solutions from "./components/solutions/solutions";

// Smooth scroll to top component
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Smooth scroll to top when route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, [pathname]);

    return null;
};

// Enhanced Home page composite component with smooth scroll container
const HomePage = ({ landingPageData }) => (
    <div className="smooth-scroll">
        <Header data={landingPageData.Header} />
        <Features data={landingPageData.Features} />
        <Home1 data={landingPageData.Home1} />
        <SpecializedTech />
        <Testimonials data={landingPageData.Testimonials} />
    </div>
);

// Enhanced 404 Not Found component
const NotFound = () => (
    <div className="min-h-screen flex items-center justify-center smooth-scroll">
        <div className="text-center">
            <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
            <p className="text-lg text-gray-600">The page you're looking for doesn't exist.</p>
        </div>
    </div>
);

// Page wrapper component to ensure consistent smooth scrolling
const PageWrapper = ({ children }) => (
    <div className="smooth-scroll">
        {children}
    </div>
);

const AppRoutes = ({ landingPageData }) => {
    const location = useLocation();

    return (
        <>
            <ScrollToTop />
            <TransitionGroup>
                <CSSTransition key={location.key} timeout={300} classNames="fade">
                    <Routes location={location}>
                        {/* Home page */}
                        <Route
                            path="/"
                            element={<HomePage landingPageData={landingPageData} />}
                        />

                        {/* Company pages */}
                        <Route
                            path="/whoweare"
                            element={
                                <PageWrapper>
                                    <WhoWeAre data={landingPageData.WhoWeAre} />
                                </PageWrapper>
                            }
                        />
                        <Route
                            path="/contact"
                            element={
                                <PageWrapper>
                                    <Contact data={landingPageData.Contact} />
                                </PageWrapper>
                            }
                        />
                        <Route
                            path="/certifications"
                            element={
                                <PageWrapper>
                                    <Certifications />
                                </PageWrapper>
                            }
                        />

                        {/* Service pages */}
                        <Route
                            path="/services"
                            element={
                                <PageWrapper>
                                    <Services data={landingPageData.Services} />
                                </PageWrapper>
                            }
                        />
                        <Route
                            path="/service/:serviceId"
                            element={
                                <PageWrapper>
                                    <ServiceDetail data={landingPageData.Services} />
                                </PageWrapper>
                            }
                        />
                        <Route
                            path="/solutions"
                            element={
                                <PageWrapper>
                                    <Solutions />
                                </PageWrapper>
                            }
                        />

                        {/* 404 catch-all */}
                        <Route
                            path="*"
                            element={<NotFound />}
                        />
                    </Routes>
                </CSSTransition>
            </TransitionGroup>
        </>
    );
};

export default AppRoutes;